import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="17" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.5 7h-1V5c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-3-9V5c0-1.66 1.34-3 3-3s3 1.34 3 3v2h-6z" fill="#07A" /></svg>;